import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '../../../types';
// import { divideBy } from '../../../styles/styleUtils';

const footerStyles = makeStyles((theme: Theme) => {
    return {
        appFooter: {
            // Appearance → Footer (palette.brandFooter), the header's navy by default.
            background: (theme.palette as any).brandFooter ?? theme.palette.grey[100],
            width: '100%',
            // Continues the nav tree's footer divider across the content area.
            // Both sit exactly --footer-height above the viewport bottom, so
            // the two draw one unbroken rule from side to side.
            borderTop: '1px solid var(--separator, #e5e7eb)',
            // Only the theme swap should animate here. On `all`, the footer's
            // own width eased itself while its parent's margin was already
            // easing — two motions for one sidebar toggle.
            transition: 'background-color 200ms ease',
            fontSize: '11px',
            color: (theme.palette as any).brandFooterText ?? theme.palette.text.secondary,
            '& .MuiTypography-root': { color: 'inherit' }
        },
        appFooterInner: {
            padding: `0 ${theme.themeVars.layoutSpacer}`,
            height: theme.themeVars.footerHeight,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            [theme.breakpoints.down('xl')]: {
                //display: 'block',
                textAlign: 'center',
                //height: 'auto',
                // padding: `0 ${divideBy(theme.themeVars.spacer, 3)} ${divideBy(theme.themeVars.spacer, 2)} ${divideBy(
                //     theme.themeVars.spacer,
                //     2
                // )}`,
                '& .MuiList-root': {
                    justifyContent: 'center',
                    '& .MuiButtonBase-root': {
                        textAlign: 'center'
                    }
                }
            }
        },
        list: {
            ...theme.globals.dFlex,
            ...theme.globals.alignItemsCenter
        },
        listItem: {
            ...theme.globals.roundedSm,
            ...theme.globals.textNowrap,
            margin: theme.spacing(0, 1),
            '& .MuiListItemText-root': {
                '& span': {
                    fontWeight: 'bold'
                }
            },
            '&:hover': {
                color: theme.palette.primary.dark
            }
        },
        red: {
            color: theme.palette.error.main
        },
        subFooter: {
            fontFamily: theme.typography.fontFamily
        },
        version: {
            fontFamily: theme.typography.fontFamily,
            // Sits opposite the copyright line, so it inherits the footer's 11px and
            // secondary colour. Tabular figures keep the number from shifting width as
            // the digits change.
            fontVariantNumeric: 'tabular-nums'
        }
    };
});
export default footerStyles;
